import {
    UNORDERED_VERTICAL_LIST_HEADLINE_TEXT_CLASSNAME,
    UnorderedVerticalList,
    createUnorderedVerticalList,
} from '@vfde-brix/ws10/unordered-vertical-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';
import { getTariffBenefitsWithFootnoteLink } from '../util/cms';
import { getElementsByBrixClassName } from '../util/component';
import { updateFootnoteLink } from './footnoteLink';
import { CmsTariffBenefit } from '../interface';
import { addTooltipTrackingEvent } from './tooltip';
import { decodeHtml } from '@vfde-sails/utils';

const HEADLINE_TEXT_CLASSNAME = `${UNORDERED_VERTICAL_LIST_HEADLINE_TEXT_CLASSNAME}--default`;

/**
 * Create Brix Unordered Vertical List component.
 *
 * @param id - Wrapper ID of the element.
 * @returns Unordered Vertical List
 * component or null if the element with the given ID is not found.
 */
export const mountVerticalList = (id: HtmlId) =>
    mountComponent(id, createUnorderedVerticalList, NO_PATTERN_BUSINESS_LOGIC);

/**
 *
 */
export const updateBenefitListFootnoteLinks = (tariffBenefits: UnorderedVerticalList | null) => {
    const headlineElements = getElementsByBrixClassName(tariffBenefits, HEADLINE_TEXT_CLASSNAME);
    const cmsBenefits = getTariffBenefitsWithFootnoteLink();

    for (const { headline, footnoteNumber } of cmsBenefits) {
        if (!footnoteNumber) {
            continue;
        }

        const benefit = headlineElements.find(headlineEl =>
            decodeHtml((headlineEl as HTMLElement).innerText).trim() === decodeHtml(headline).trim(),
        );

        benefit && updateFootnoteLink(benefit, footnoteNumber);
    }
};

/**
 * Adds tooltip tracking event for every tariff benefit items
 *
 * @param benefitList - UnorderedVerticalList brix component
 * @param cmsBenefits - CMS configured benefits
 */
export const addBenefitListTooltipTrackingEvent = (
    benefitList: UnorderedVerticalList | null,
    cmsBenefits: CmsTariffBenefit[],
) => {
    benefitList?.getPropertyByKey('listUnorderedVerticalListItems').map((item, index) => {
        const tooltipProps = item.containerTooltip;
        const tooltip = cmsBenefits[index]?.tooltip;

        if (tooltip && tooltipProps) {
            addTooltipTrackingEvent(tooltipProps.stdTooltipId);
        }
    });
};
